// Copied from ds/src/app/layouts/Sideblock/index.tsx
import { useLayoutEffect } from 'react';
import { Outlet } from 'react-router';

import { Sidebar } from './Sidebar';
import { Header } from './Header';

export default function Sideblock() {
  useLayoutEffect(() => {
    document.body.dataset.layout = 'sideblock';
    return () => {
      delete document.body.dataset.layout;
    };
  }, []);

  return (
    <>
      <Header />
      <main className="main-content transition-content grid grid-cols-1">
        <Outlet />
      </main>
      <Sidebar />
    </>
  );
}
